import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import ReportIcon from '../Assests/Report.svg'; // Corrected case
import './ReportProfileDialog.css';
import PropTypes from 'prop-types';

const REASONS = [
  'Inappropriate content',
  'Spam or scams',
  'Harassment or bullying',
  'False information',
  'Other',
];

const ReportProfileDialog = ({ open, onClose, userName = 'User', onReport }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [otherDetails, setOtherDetails] = useState('');

  const handleReasonChange = (reason) => {
    setSelectedReason(reason);
    if (reason !== 'Other') setOtherDetails('');
  };
  const handleReport = () => {
    if (selectedReason === 'Other' && !otherDetails.trim()) return;
    if (selectedReason) {
      onReport(selectedReason === 'Other' ? { reason: selectedReason, details: otherDetails } : selectedReason);
      onClose();
    }
  };

  // Dynamic height based on selection
  const dialogHeight = selectedReason === 'Other' ? 637 : 561;

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ style: { background: 'transparent', boxShadow: 'none' } }} hideBackdrop>
      <div className="report-dialog-content" style={{ height: dialogHeight, position: 'relative' }}>
        <div className="report-dialog-header">
          <span>Report This Profile</span>
          <button className="report-dialog-close" onClick={onClose}>&times;</button>
        </div>
        <div className="report-dialog-body">
          <div className="report-dialog-description">
            Let us know why you're reporting [ {userName} ]. Our team will review this profile and take appropriate action.<br/>
            This report is confidential and the user will not be notified.
          </div>
          <div className="report-dialog-reasons">
            <div className="report-dialog-reasons-title">Reason for reporting</div>
            {REASONS.map((reason) => (
              <label key={reason} className="report-dialog-reason">
                <input
                  type="radio"
                  name="report-reason"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={() => handleReasonChange(reason)}
                />
                <span className="report-dialog-custom-radio" />
                <span className="report-dialog-reason-text">{reason}</span>
              </label>
            ))}
            {selectedReason === 'Other' && (
              <div className="report-dialog-other-details">
                <div className="report-dialog-other-label">Add more details</div>
                <textarea
                  className="report-dialog-other-textarea"
                  placeholder="Write any specific behavior or example..."
                  value={otherDetails}
                  onChange={e => setOtherDetails(e.target.value)}
                  rows={3}
                  required
                />
              </div>
            )}
          </div>
        </div>
        <div className="report-dialog-actions">
          <button className="report-dialog-cancel" onClick={onClose}>Cancel</button>
          <button
            className="report-dialog-report"
            onClick={handleReport}
            disabled={!selectedReason || (selectedReason === 'Other' && !otherDetails.trim())}
          >
            <span>Report</span>
            <img src={ReportIcon} alt="Report" className="report-dialog-report-icon" style={{ marginLeft: 8 }} />
          </button>
        </div>
      </div>
    </Dialog>
  );
};

ReportProfileDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userName: PropTypes.string,
  onReport: PropTypes.func.isRequired,
};

export default ReportProfileDialog; 